/** @jsx jsx */
import { useState, useRef, useEffect } from "react"
import { jsx, Flex, Button, Text, Box } from "theme-ui"
import styled from "@emotion/styled"
import Icon from "./Icon"
import Action from "./Action"

const DropdownContainer = styled.div`
  .menu-trigger {
    cursor: pointer;
    margin: 0;
    padding: 0;
  }

  .menu-2 {
    background: ${(t) => t.theme.colors.white};
    width: 100%;
    visibility: hidden;
    height: 0;
    transition: height 0.6s ease;
    z-index: -1;
  }

  .menu-2.active {
    visibility: visible;
    height: auto;
    position: relative;
    z-index: 99;
  }

  .menu-2 ul {
    padding-left: 5px;
  }

  .menu {
    background: ${(t) => t.theme.colors.white};
    border-radius: 10px;
    position: absolute;
    width: inherit;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    opacity: 0;
    visibility: hidden;
    transform: translateY(0px);
    transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
    z-index: 99;
  }

  .menu.active {
    opacity: 1;
    visibility: visible;
    transform: translateY(40px);
    box-shadow: 0px 10px 50px #00000041;
  }

  .menu ul {
    padding: 0;
  }
`

const DropdownMenu = ({ dropdown, isFirstLevel = false }) => {
  const dropdownRef = useRef(null)
  const [isActive, setIsActive] = useState(false)
  const onClick = (e) => {
    e.stopPropagation()
    setIsActive((prevState) => !prevState)
  }

  const dropdownLinks = dropdown.links
  const dropdownClassName = !isFirstLevel ? "menu-2" : "menu"

  useEffect(() => {
    const pageClickEvent = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsActive(false)
      }
    }

    if (isActive) {
      window.addEventListener("click", pageClickEvent)
    }

    return () => {
      window.removeEventListener("click", pageClickEvent)
    }
  }, [isActive])

  // Assign conditional rendering to a variable
  const actionOrButton = dropdown.dropdownMainLink ? (
    <Flex sx={{ alignItems: "center", pr: "5px", width: "100%", justifyContent: "space-between" }}>
      <Action
        onFinish={() => setIsActive(false)}
        key={dropdown.id}
        url={dropdown.dropdownMainLink}
        label={dropdown.dropdownTitle}
        fontColor="#272763"
        iconColor="#272763"
        width="100%"
        fontsize="14px"
        style={"linkV2 Gray"}
        backgroundColorForText="#ffcbaf"
        paddingCustom={["5px 10px"]}
      />
      <Button
        aria-expanded={isActive}
        onClick={onClick}
        sx={{
          border: "none",
          background: "none",
          fontSize: "inherit",
          width: "20px",
          height: "20px",
          padding: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          variant: "navLink",
          flexShrink: 0,
          margin: 0,
          ":hover": {
            boxShadow: "0px 0px 3px 1px #efefef",
            borderRadius: "2px",
          },
        }}
      >
        <Icon
          icon="down-chevron"
          sx={{ transform: isActive && "rotate(180deg)", minWidth: "14px", minHeight: "14px" }}
          color={isActive && "#FF6310"}
        />
      </Button>
    </Flex>
  ) : (
    <Flex
      as="div"
      className="menu-trigger"
      sx={{
        variant: "navLink",
        alignItems: "center",
      }}
    >
      <Button
        aria-expanded={isActive}
        onClick={onClick}
        sx={{
          border: "none",
          background: "none",
          fontSize: "inherit",
          margin: 0,
          padding: 0,
          variant: "navLink",
        }}
      >
        <Text sx={{ color: isActive && "orangeV2", fontSize: "14px" }}>{dropdown.dropdownTitle.toUpperCase()}</Text>
        <Icon
          icon="down-chevron"
          sx={{ marginLeft: "4px", transform: isActive && "rotate(180deg)" }}
          color={isActive && "#FF6310"}
        />
      </Button>
    </Flex>
  )

  return (
    <DropdownContainer tabIndex="0" aria-expanded={isActive} sx={{ width: "100%" }}>
      <Flex
        sx={{
          variant: "navLink",
          alignItems: "center",
          margin: 0,
          padding: 0,
          flexWrap: "wrap",
          flexDirection: "column",
          width: "100%",
          position: "relative",
        }}
        className="subnav-secondary"
      >
        {/* Render the variable here */}
        {actionOrButton}

        <Box
          ref={dropdownRef}
          aria-expanded={isActive}
          className={`${dropdownClassName} ${isActive ? "active" : "inactive"}`}
        >
          <ul sx={{ pl: "20px" }}>
            {dropdownLinks.map((link) => (
              <li
                key={link.id}
                sx={{
                  variant: "navListItem",
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                className="main_nav_action_btn"
              >
                <Action
                  onFinish={() => setIsActive(false)}
                  key={link.id}
                  {...link}
                  fontColor="#272763"
                  iconColor="#272763"
                  width="100%"
                  fontsize="14px"
                  backgroundColorForText="#ffcbaf"
                  classnameForAnalytics={link.classnameForAnalytics}
                />
              </li>
            ))}
          </ul>
        </Box>
      </Flex>
    </DropdownContainer>
  )
}

export default DropdownMenu
